import { SharedState } from '@trello/shared-state';
// eslint-disable-next-line no-restricted-imports
import type {
  BoardsMenuSelectedItemModel,
  ReopenBoardPopoverModel,
} from 'app/gamma/src/types/models';
import { getRecentBoards } from '@trello/recent-boards';

export interface BoardsMenuState {
  idBoardsStarred: string[];
  idRecentBoards: string[];
  isDeletingBoard: {
    [key: string]: boolean;
  };
  loading: boolean;
  pastQueries: {
    query: string;
    limited: boolean;
  }[];
  reopenBoardPopover: ReopenBoardPopoverModel | null;
  searchText: string;
  selectedBoard: BoardsMenuSelectedItemModel | null;
}

// eslint-disable-next-line @trello/no-module-logic
const idRecentBoards = getRecentBoards().map((board) => board.id);
const initialState: BoardsMenuState = {
  idBoardsStarred: [],
  idRecentBoards,
  isDeletingBoard: {},
  loading: false,
  pastQueries: [],
  reopenBoardPopover: null,
  searchText: '',
  selectedBoard: null,
};

// This is defined/exported in this file instead of boards-menu.ts to avoid circular dependencies.
export const boardsMenuState = new SharedState<BoardsMenuState>(initialState);
